module.exports = __webpack_public_path__ + "img/Azrtx b  oaxrd – 2.f4a0a38b.png";